'use client';

import { useEffect, useState } from 'react';
import { Dialog, DialogBackdrop, DialogPanel, TransitionChild } from '@headlessui/react';
import {
  Bars3Icon,
  CalendarIcon,
  DocumentDuplicateIcon,
  HomeIcon,
  UsersIcon,
  XMarkIcon,
  UserIcon,
  CalendarDaysIcon,
  BellIcon,
  ArrowPathRoundedSquareIcon,
  Cog6ToothIcon,
  WalletIcon,
  ChartBarIcon,
  DocumentArrowUpIcon,
  PowerIcon,
  ClipboardDocumentCheckIcon,
  DocumentCheckIcon,
  CalendarDateRangeIcon,
  PencilIcon,
  CheckBadgeIcon,
  ChevronDoubleRightIcon,


} from '@heroicons/react/20/solid';
import { BookOpenIcon, ScaleIcon, UserGroupIcon } from '@heroicons/react/24/solid';
import { Link, useNavigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

import WeatherData from './weatherdata';

import { ChatBubbleBottomCenterIcon } from '@heroicons/react/16/solid';
import { useContext } from 'react';
import { AuthContext } from '../AuthContext';
import MessageAlert from './messagealert';
import TaskHome from './taskhome';

import LoadingComponent from './loading';
import { format } from 'date-fns';
import ReactFlow, {
    Controls,
    Background,
    applyNodeChanges,
    applyEdgeChanges,
  } from "reactflow";
  import "reactflow/dist/style.css";

  import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/20/solid'
import { CursorArrowRaysIcon, EnvelopeOpenIcon } from '@heroicons/react/24/outline'
import { AcademicCapIcon } from '@heroicons/react/24/solid'
import  ProjectDailyTasks from './projectdailytasks';
import { useLocation } from 'react-router-dom';





const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: HomeIcon, current: true },
    { name: 'Chat', href: '/chatdashboard', icon: ChatBubbleBottomCenterIcon, current: false },
    { name: 'My Profile', href: '/myprofile', icon: UserIcon, current: false },
    { name: 'Organization', href: '/organizationaltree', icon: ScaleIcon, current: false },
    { name: 'Task Manager', href: '/taskcalendar', icon: CalendarDateRangeIcon, current: false },
    { name: 'Admin Tasks', href: '/admin-tasks', icon: DocumentCheckIcon, current: false },
    { name: 'Training', href: '/training', icon: AcademicCapIcon, current: false },
    { name: 'Users', href: '/users', icon: UserGroupIcon, current: false },
    { name: 'Billing', href: '/billing', icon: WalletIcon, current: false },
    { name: 'Log Out', href: '/logout', icon: PowerIcon, current: false },
   
    ];







function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Admin({prop}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
    const [openProjectModal, setOpenProjectModal] = useState(false);
    const [processes, setProcesses] = useState([]);
    const [formData, setFormData] = useState({
      name: "",
      description: "",
      startDate: "",
      endDate: "",
      process: [], // Store selected processes as an array
      objective: "",
    
    });
    const [openReport, setOpenReport] = useState(false);
    const [loading, setLoading] = useState(false);
const [directory, setDirectory] = useState({});
const [projectSteps, setProjectSteps] = useState([]);
const [projectId, setProjectId] = useState(null);
const [isFullscreen, setIsFullscreen] = useState(false);
const [openProjectSteps, setOpenProjectSteps] = useState(false);
const [projectName, setProjectName] = useState(null);
const [meetings, setMeetings] = useState([]);

console.log(projectName);
  
    // Handle input changes for the form
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    };
  
    // Handle process selection change (for multiple processes)
    const handleSelectChange = (e) => {
      const { name, options } = e.target;
      const selectedValues = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
  
      setFormData((prevData) => ({
        ...prevData,
        [name]: selectedValues, // Store selected values as an array
      }));
    };

    console.log(formData)
  
    // Handle form submission
    const handleSubmit = async (e) => {
        
      e.preventDefault();
      setLoading(true);

      try {
        const response = await fetch("https://api.insightos.co.uk/api/aiprojectreport", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: 'include',
          body: JSON.stringify(formData),
        });
        const data = await response.json();
        if (response.ok) {



            setOpenReport(data.data)
            setLoading(false);

          // Reset form or handle response here as needed
        } else {
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

    const toggleFullscreen = () => {
        setIsFullscreen(!isFullscreen);
      };
  
    // Fetch processes from the API
    const getProcess = async () => {
        
      try {
        const response = await fetch("https://api.insightos.co.uk/api/process", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
           },
           credentials: 'include',

        });
        const data = await response.json();
  
        if (data.success) {
          setProcesses(data.data); // Update processes state with the fetched data
        } else {
          console.error("Failed to fetch processes:", data.message);
        }
      } catch (error) {
        console.error("Error fetching processes:", error);
      }
    };

    const fetchProjects = async () => {
        const token = localStorage.getItem("token");    

        try {
            const response = await fetch("https://api.insightos.co.uk/api/getproject", {
                method: "GET",

                headers: { "Content-Type": "application/json",

                },
                credentials: 'include',
            });
            const data = await response.json();

            if (data.success) {
                const dir = data.data.reduce((acc, proc) => {
                    const letter = proc.Name[0].toUpperCase();
                    if (!acc[letter]) acc[letter] = [];
                    acc[letter].push(proc);
                    acc[letter].sort((a, b) => a.Name.localeCompare(b.Name));
                    return acc;
                  }, {});
                  setDirectory(dir);            } else {
                console.error("Failed to fetch projects:", data.message);
            }

        } catch (error) {

            console.error("Error fetching projects:", error);

        }

    };


    // i want to get project steps when the useLocation triggers the project id

    const location = useLocation();


    useEffect(() => {

        if (location.state) {

            // get the project id from the location state

            const projectId = location.state.projectId;

            // now we want to get the steps for this project

            handleGetSteps(projectId);

        }

    }, [location]);



    useEffect(() => {

handleGetSteps(prop);

    }, [prop]);


const Navigate = useNavigate();




    useEffect(() => {
        fetchProjects();
    }, []);



  
    // Fetch processes when the component mounts or the modal opens
    useEffect(() => {
      if (openProjectModal) {
        getProcess(); // Fetch processes when the modal is open
      }
    }, [openProjectModal]);

    const handleSaveData = async () => {
        setLoading(true);
    
        try {
            // Create a new object to avoid mutating state directly
            const requestData = { ...formData, openReport };
    
            const response = await fetch("https://api.insightos.co.uk/api/projectsave", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: 'include',
                body: JSON.stringify(requestData),
            });
    
            // Check if the response is OK before parsing JSON
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
    
            const data = await response.json();
    
            if (response.status === 202 && data.queued && data.jobId) {
                setOpenProjectModal(false);
                setOpenReport(false);
                Navigate(`/job-progress/${data.jobId}`, {
                  state: {
                    title: 'Creating project schedule',
                    successPath: '/project-management',
                    backPath: '/project-management',
                  },
                });
                return;
            }

            if (data.success) {
                console.log("Data saved successfully:", data);
                setOpenProjectModal(false);
                setOpenReport(false);                
                fetchProjects();
            } else {
                console.error("Server responded with an error:", data);
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleGetSteps = async (id, name) => {

        try {
            const response = await fetch(`https://api.insightos.co.uk/api/getprojectsteps/${id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: 'include',
            });
            const data = await response.json();

            if (response.ok) {

                // now we want to sort the tasks using the TaskDate and StartTime

                const sortedData = data.data.sort((a, b) => {
                    const dateA = new Date(a.TaskDate + " " + a.StartTime);
                    const dateB = new Date(b.TaskDate + " " + b.StartTime);
                    return dateA - dateB;
                });

                console.log("Project steps:", sortedData);
                setProjectSteps(sortedData);
                setOpenProjectSteps(true);
                setProjectId(id);
                setProjectName(name);

                const meetings = data.meetings 

                console.log("Meetings:", meetings);

                setMeetings(meetings);


            } else {

                console.error("Failed to fetch project steps:", data.message);

            }

        } catch (error) {

            console.error("Error fetching project steps:", error);

        }

    };

    useEffect(() => {
        // if projectSteps is not empty, then set a timeout on handleGetSteps to refresh the data every 5 minutes
        if (projectSteps.length > 0) {
            const interval = setInterval(() => {
                handleGetSteps(projectId);
                currentProgress();
            }, 60000); // 5 minutes
            return () => clearInterval(interval);
        }
    }, [projectSteps]);


    const [selectedNode, setSelectedNode] = useState(null); // To store the selected node's data

    const handleNodeClick = (event, node) => {
      // Find the node data and set it to the selectedNode state
      const selectedStep = projectSteps.find(step => step.TaskID.toString() === node.id);
      setSelectedNode(selectedStep);
    };
  
    const nodeSpacingX = 140; // 🔽 Reduce horizontal spacing
    const nodeSpacingY = 400; // 🔽 Reduce vertical spacing
  
    // 🛠 Group steps by ProcessId (Each ProcessId gets its own row)
    const groupedSteps = projectSteps.reduce((acc, step) => {
      if (!acc[step.ProcessId]) acc[step.ProcessId] = [];
      acc[step.ProcessId].push(step);
      return acc;
    }, {});
  
    const nodes = Object.entries(groupedSteps).flatMap(([processId, steps], rowIndex) =>
      steps.flatMap((step, colIndex) => {
        const isCompleted = step.Completed === 1;
        const backgroundColor = isCompleted ? "#00FF88" : "#FF3131"; // 🟢 Completed / 🔴 Not Completed
        const nodesList = [];
  
        // 🔷 Main Step Node with position indicator
        nodesList.push({
          id: step.TaskID?.toString(),
          data: { label: `${colIndex + 1}/${steps.length}: ${step.Role} - ${step.Name} - ${step.Task} (${step.Description}) ${step.StartTime} (${format(new Date(step.TaskDate), "dd/MM/yyyy")})` },
          position: { x: colIndex * nodeSpacingX, y: rowIndex * nodeSpacingY },
          style: {
            background: backgroundColor,
            color: "#fff",
            borderRadius: "10px",
            boxShadow: `0px 0px 8px ${backgroundColor}`,
            padding: "8px",
            fontSize: "12px",
            width: 120,
          },
        });
  
        // 🟡 Issue Nodes (Circles)
        (step.issues || []).forEach((issue, issueIndex) => {
          nodesList.push({
            id: `issue-${step.TaskID}-${issueIndex}`,
            data: { label: issue.Name || "Issue" },
            position: { x: colIndex * nodeSpacingX + 50, y: rowIndex * nodeSpacingY + 220 + issueIndex * 50 },
            style: {
              background: "#FFD700",
              color: "#000",
              borderRadius: "50%", // 🟡 Circle shape
              width: 50,
              height: 50,
              fontSize: "10px",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0px 0px 6px #FFD700",
            },
          });
  
          // Add help nodes if issue has help info (may be multiple)
          if (issue.help && issue.help.length > 0) {
            issue.help.forEach((helpItem, helpIndex) => {
              nodesList.push({
                id: `help-${step.TaskID}-${issueIndex}-${helpIndex}`,
                data: { label: helpItem.StaffName },
                position: { 
                  x: colIndex * nodeSpacingX + 0, 
                  y: rowIndex * nodeSpacingY + 300 + issueIndex * 50 + helpIndex * 30 
                },
                style: {
                  background: "#4A90E2",
                  color: "#fff",
                  borderRadius: "5px",
                  padding: "5px",
                  fontSize: "10px",
                  width: 100,
                  boxShadow: "0px 0px 6px #4A90E2",
                },
              });
            });
          }
        });
  
        return nodesList;
      })
    ).flat();
  
    const edges = Object.entries(groupedSteps).flatMap(([processId, steps]) =>
      steps.flatMap((step, index, array) => {
        const mainStepId = step.TaskID?.toString();
        const edgesList = [];
  
        // 🔹 Edges between issues and their step
        (step.issues || []).forEach((issue, issueIndex) => {
          const issueId = `issue-${step.TaskID}-${issueIndex}`;
          
          edgesList.push({
            id: `e-${mainStepId}-issue-${issueIndex}`,
            source: mainStepId,
            target: issueId,
            animated: true,
            style: { stroke: "#FFD700", strokeWidth: 1.5 },
          });
          
          // 🔷 Add edges from issue to each help item
          if (issue.help && issue.help.length > 0) {
            issue.help.forEach((helpItem, helpIndex) => {
              edgesList.push({
                id: `e-issue-${step.TaskID}-${issueIndex}-help-${helpIndex}`,
                source: issueId,
                target: `help-${step.TaskID}-${issueIndex}-${helpIndex}`,
                animated: true,
                style: { stroke: "#4A90E2", strokeWidth: 1.5, strokeDasharray: "5 5" },
              });
            });
          }
        });
  
        // 🔹 Connect steps within the same ProcessId (same row)
        if (index > 0) {
          edgesList.push({
            id: `e-${array[index - 1].TaskID}-${step.TaskID}`,
            source: array[index - 1].TaskID?.toString(),
            target: mainStepId,
            animated: true,
            style: { stroke: "#FFFFFF", strokeWidth: 1.5 },
          });
        }
  
        return edgesList;
      })
    ).flat();

    // now we want to work out the stats for the project so if we are ahead or behind so we need to map through projectSteps to find out how many steps for each day and then how many are completed

const currentProgress = () => {
    const today = new Date();

    // use date fns to match today with the .TaskDate 
    const stepsToday = projectSteps.filter(step => format(new Date(step.TaskDate), "dd/MM/yyyy") === format(today, "dd/MM/yyyy"));

    // okay now using today get the current time and use the StartTime which is hh:mm:ss to see how many tasks are up to this time

    // use date fns to get the current time

    const currentTime = format(today, "HH:mm:ss");

    // now we need to filter the stepsToday to see how many are up to the current time

    const stepsUpToNow = stepsToday.filter(step => step.StartTime <= currentTime);

    console.log("Steps up to now:", stepsUpToNow);

    console.log("Steps today:", stepsToday);

   // find out with steps up to now how many are completed

    const completedSteps = stepsUpToNow.filter(step => step.Completed === 1).length;

    




   

    return {
        totalSteps: stepsToday.length,
        completedSteps
      
    };

};

console.log(currentProgress());

const overallProgress = () => {
    // Check if projectSteps is empty
    if (projectSteps.length === 0) {
        return {
            totalSteps: 0,
            completedSteps: 0
        };
    }

    const today = new Date();
    const currentDate = format(today, "dd/MM/yyyy");
    const currentTime = format(today, "HH:mm:ss");
    
    // Get all steps up to now (steps from previous days + today's steps up to current time)
    const stepsUpToNow = projectSteps.filter(step => {
        const stepDate = format(new Date(step.TaskDate), "dd/MM/yyyy");
        
        // Include if step date is before today
        if (stepDate < currentDate) return true;
        
        // Include if step date is today AND step time is up to current time
        if (stepDate === currentDate && step.StartTime <= currentTime) return true;
        
        return false;
    });
    
    // Count completed steps
    const completedSteps = stepsUpToNow.filter(step => step.Completed === 1).length;
    
    console.log("Steps up to now:", stepsUpToNow);
    console.log(`Overall progress: ${completedSteps}/${stepsUpToNow.length} steps completed`);

    // each step is an hour so show how many hours we are behind or if we are on track



    

    
    return {
        totalSteps: stepsUpToNow.length,
        completedSteps
    };
};


console.log(overallProgress());



const NodeDetailsModal = ({ nodeData, onClose }) => {
    if (!nodeData) return null;
  
    const bgColor = nodeData.Completed === 1 ? "bg-emerald-500" : "bg-red-500";
  
    return (
        <div className="flex items-center justify-center bg-black bg-opacity-50 w-full h-full z-50">
          <div className={`shadow-lg rounded-lg p-4 w-80 text-white ${bgColor}`}>
            {/* Header */}
            <div className="p-2 text-sm font-semibold text-center">Node Details</div>
      
            {/* Content */}
            <div className="p-2 space-y-2 text-xs">
              <p><strong>Role:</strong> {nodeData.Role}</p>
              <p><strong>Task:</strong> {nodeData.Task}</p>
              <p><strong>Description:</strong> {nodeData.Description}</p>
              <p><strong>Start Time:</strong> {nodeData.StartTime}</p>
              <p><strong>Task Date:</strong> {nodeData.TaskDate}</p>
              {nodeData !== null && (
                <p ><strong>Outcome:</strong> {nodeData.Outcome}</p>
              )}
      
              {/* Issues Section */}
              {nodeData.issues?.length > 0 && (
                <div className="mt-2">
                  <h3 className="font-semibold text-sm">Issues:</h3>
                  {nodeData.issues.map((issue, index) => (
                    <div key={index} className="p-2 rounded border border-white mt-1">
                      <p><strong>Issues:</strong> {issue.length} issues</p>
      
                      {issue.help?.length > 0 && (
                        <div className="mt-1">
                          <h4 className="font-semibold text-xs">Help:</h4>
                          {issue.help.map((helpItem, helpIndex) => (
                            <div key={helpIndex} className="p-1 rounded border border-white mt-1">
                              <p><strong>{helpItem.StaffName}</strong></p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
      
            {/* Close Button */}
            <div className="p-2 flex justify-end">
              <button onClick={onClose} className="px-3 py-1 bg-white text-black rounded hover:bg-gray-300 text-xs">
                Close
              </button>
            </div>
          </div>
        </div>
      );
      
  };



  
    const stats = [
        {
            id: 1,
            name: "Total Project Steps",
            stat: projectSteps.length || "0",
            change: "100%",
            changeType: "increase",
            icon: DocumentDuplicateIcon,
        },
        {
            id: 2,
            name: "Completed Steps",
            stat: projectSteps.length > 0 
                ? `${Math.round((projectSteps.filter(step => step.Completed === 1).length / projectSteps.length) * 100)}%` 
                : "0%",
            change: `${projectSteps.filter(step => step.Completed === 1).length || "0"} steps`,
            changeType: "increase",
            icon: ClipboardDocumentCheckIcon,
        },
        {
            id: 3,
            name: "Pending Steps",
            stat: projectSteps.length > 0 
                ? `${Math.round((projectSteps.filter(step => step.Completed !== 1).length / projectSteps.length) * 100)}%` 
                : "0%",
            change: `${projectSteps.filter(step => step.Completed !== 1).length || "0"} steps`,
            changeType: "decrease",
            icon: DocumentCheckIcon,
        },
        {
            id: 4,
            name: "Current Daily Progress",
            stat: currentProgress().totalSteps > 0 
                ? `${Math.round((currentProgress().completedSteps / currentProgress().totalSteps) * 100)}%` 
                : "0%",
            change: (() => {
                const prog = currentProgress();
                const hoursDiff = prog.totalSteps - prog.completedSteps;
                return hoursDiff > 0 
                    ? `${hoursDiff} hour${hoursDiff !== 1 ? 's' : ''} behind` 
                    : hoursDiff < 0 
                        ? `${Math.abs(hoursDiff)} hour${Math.abs(hoursDiff) !== 1 ? 's' : ''} ahead` 
                        : "On target";
            })(),
            changeType: currentProgress().totalSteps > 0 && 
                (currentProgress().completedSteps / currentProgress().totalSteps) < 0.9 
                    ? "decrease" : "increase",
            icon: ArrowPathRoundedSquareIcon,
        },
        {
            id: 5,
            name: "Overall Progress",
            stat: overallProgress().totalSteps > 0 
                ? `${Math.round((overallProgress().completedSteps / overallProgress().totalSteps) * 100)}%` 
                : "0%",
            change: `${overallProgress().completedSteps}/${overallProgress().totalSteps} steps`,
            changeType: overallProgress().totalSteps > 0 && 
                (overallProgress().completedSteps / overallProgress().totalSteps) < 0.9 
                    ? "decrease" : "increase",
            icon: ArrowPathRoundedSquareIcon,
        },
    ];
    
    




return (
    <>
        <div>
       
{openProjectSteps && (
                <>
                <div className="container mx-auto px-6">
                    {/* Back button */}
                    
                    
                    
                    {/* Stats Section */}
                    <div className="bg-black p-6 shadow-md rounded-lg mt-10 relative">
                        <h3 className="text-lg font-semibold text-white">{projectName}</h3>
            
                        {/* Fullscreen Toggle Button */}
                        <button
                            onClick={toggleFullscreen}
                            className="mt-4 bg-blue-600 hover:bg-blue-700 transition text-white font-medium px-5 py-2 rounded-lg"
                          data-component="project-meeting-flow"
                          data-feature={isFullscreen ? "exit_fullscreen" : "enter_fullscreen"}
                        >
                            {isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                        </button>
            
                        {/* Fullscreen Mode */}
                        <div
                            className={`transition-all duration-300 ease-in-out ${
                                isFullscreen ? "fixed inset-0 z-50" : "w-full h-80"
                            } bg-[#0A0F1E] rounded-xl shadow-lg overflow-hidden`}
                        >
                            {/* Close Fullscreen Button */}
                            {isFullscreen && (
                                <button
                                    onClick={toggleFullscreen}
                                    className="absolute top-5 right-5 bg-red-500 hover:bg-red-600 transition text-white px-4 py-2 rounded-lg z-10"
                                  data-component="project-meeting-flow"
                                  data-feature="close_fullscreen"
                                >
                                    Close Fullscreen
                                </button>
                            )}
            
                            {/* ReactFlow Component */}
                            <ReactFlow
                                nodes={nodes}
                                edges={edges}
                                fitView
                                style={{ width: "100%", height: "100%" }}
                                onNodeClick={handleNodeClick}
                            >
                                <Controls />
                                <Background color="#444" gap={16} />
                            </ReactFlow>
            
                            {/* Node Details Modal */}
                            {selectedNode && (
  <div className="absolute bottom-0 left-0 w-full p-4 bg-gray-800 bg-opacity-90 rounded-t-xl">
    <NodeDetailsModal nodeData={selectedNode} onClose={() => setSelectedNode(null)} />
  </div>
)}

                        </div>
                    </div>
                    <div className="mt-10">
                        <dl className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                            {stats.map((item) => (
                                <div
                                    key={item.id}
                                    className="relative overflow-hidden rounded-xl bg-white px-6 py-5 shadow-lg hover:shadow-xl transition duration-300"
                                >
                                    {/* Icon */}
                                    <dt className="flex items-center">
                                        <div className="rounded-md bg-indigo-500 p-3">
                                            <item.icon aria-hidden="true" className="size-6 text-white" />
                                        </div>
                                        <p className="ml-4 text-sm font-medium text-gray-500">{item.name}</p>
                                    </dt>
            
                                    {/* Statistic & Change Indicator */}
                                    <dd className="mt-3 flex items-center">
                                        <p className="text-3xl font-semibold text-gray-900">{item.stat}</p>
                                        <p
                                            className={classNames(
                                                item.changeType === "increase" ? "text-green-600" : "text-red-600",
                                                "ml-2 flex items-center text-sm font-semibold"
                                            )}
                                        >
                                            {item.changeType === "increase" ? (
                                                <ArrowUpIcon aria-hidden="true" className="size-5 text-green-500" />
                                            ) : (
                                                <ArrowDownIcon aria-hidden="true" className="size-5 text-red-500" />
                                            )}
                                            <span className="sr-only">
                                                {item.changeType === "increase" ? "Increased" : "Decreased"} by
                                            </span>
                                            {item.change}
                                        </p>
                                    </dd>
                                </div>
                            ))}
                        </dl>
                    </div>
                    <div className="mt-10">
                        {meetings.length > 0 && (
                            <div className="bg-white p-6 rounded-lg shadow-md">
                                <h3 className="text-lg font-semibold text-gray-900">Meetings</h3>
                                <ul className="mt-4 space-y-4">
                                {meetings.map((meeting) => {
  let meetingBackgroundColor = "bg-green-100"; // Default color
  let statusText = "Not Started";
  let showCancelButton = true;

  if (meeting.Start === 1 && meeting.Finished === 1) {
    meetingBackgroundColor = "bg-purple-100"; // Purple background for completed meeting
    statusText = "Meeting Completed";
    showCancelButton = false; // Hide Cancel button
  } else if (meeting.Start === 1 && meeting.Finished === 0) {
    meetingBackgroundColor = "bg-green-100 animate-pulse"; // Green background for in-progress meeting
    statusText = "In Progress";
  }

  return (
    <li 
      key={meeting.id} 
      className={`flex items-center justify-between p-4 rounded-lg shadow-md transition-all ${meetingBackgroundColor}`}
    >
      <div>
        <h4 className="text-base font-semibold text-gray-900">{meeting.Name}</h4>
        <p className="mt-1 text-sm text-gray-600">{meeting.Notes}</p>
        
        {/* Status Display */}
        <p className="mt-2 text-sm font-semibold text-gray-800">{statusText}</p>

        {/* Button to open Meeting Notes (Only shown if Notes exist) */}
        {meeting.MeetingNotes && (
          <button 
            onClick={() => alert(meeting.MeetingNotes)} 
            className="mt-2 text-sm text-indigo-600 underline"
          >
            View Notes
          </button>
        )}

        {/* Cancel Button (Only shown if meeting is not completed) */}
        {showCancelButton && (

<button  onClick={() => {
  const message = meeting
Navigate('/meeting', { state: { meeting: message } });
}}
            className="mt-2 bg-red-500 text-white px-3 py-1 rounded-md text-sm shadow hover:bg-red-600 transition"
            data-component="project-meeting-meetings"
            data-feature="open_meeting_session"
            data-meeting-id={meeting.id}
          >
            Cancel Meeting
          </button>
        )}
      </div>
      
      <div className="flex items-center gap-x-4">
        <p className="text-sm text-gray-600">{format(new Date(meeting.Date), "dd/MM/yyyy")}</p>
        <p className="text-sm text-gray-600">{meeting.Time}</p>
      </div>
    </li>
  );
})}

                                </ul>
                            </div>
                        )}
                    </div>
            
                    {/* 🌐 Process Flow Visualization */}
                
            
                    {/* Project Daily Tasks */}
                    <div className="w-full mt-10">
                        <ProjectDailyTasks ProjectId={projectId} ProjectName = {projectName} />
                    </div>
                </div>
            </>
            )}          
                 

                    




                

                    {/* Tabs for Larger Screens */}
             
                    {/* Content Rendering */}
                 
                 </div>
                

    </>
);
}
